<template>
    <v-container>
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
            <v-container style="text-align: center">
                <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
                <p class="pt-2" style="font-size: 14px; color: #234a98">
                    {{ $t('common.loading') }}
                </p>
            </v-container>
        </v-overlay>

        <!-- Filtri (solo su dati già ricevuti, nessuna chiamata API) -->
        <v-card class="mt-4 mb-4">
            <v-layout id="makeMeBlue" row wrap class="align-start justify-center">
                <v-flex xs12 sm6 md2 class="mt-4 mb-4 px-2">
                    <v-select prepend-inner-icon="mdi-home" v-model="buildingValue" :items="buildings" :label="$t('manageSensors.building')"
                        outlined append-icon="mdi-arrow-down-drop-circle-outline" :no-data-text="$t('common.noDataAvailable')"
                        clearable dense>
                    </v-select>
                </v-flex>
                <v-flex xs12 sm6 md2 class="mt-4 mb-4 px-2">
                    <v-select prepend-inner-icon="mdi-floor-plan"
                        append-icon="mdi-arrow-down-drop-circle-outline" v-model="floorValue" :items="floors"
                        :label="$t('manageSensors.floor')" outlined :key="floorKey" :no-data-text="$t('common.noDataAvailable')"
                        clearable dense>
                    </v-select>
                </v-flex>
                <v-flex xs12 sm6 md2 class="mt-4 mb-4 px-2">
                    <v-select v-model="areaValue" color="#213A8F" outlined :items="areas" :label="$t('manageSensors.area')"
                        prepend-inner-icon="mdi-texture-box" append-icon="mdi-arrow-down-drop-circle-outline"
                        append-icon-color="#213A8F" :no-data-text="$t('common.noDataAvailable')" clearable dense />
                </v-flex>
                <v-flex xs12 sm6 md2 class="mt-4 mb-4 px-2">
                    <v-text-field
                        v-model="operatorSearch"
                        :label="$t('cleaningLog.searchOperator')"
                        prepend-inner-icon="mdi-account-search"
                        outlined
                        clearable
                        color="#213A8F"
                        :placeholder="$t('cleaningLog.searchOperatorPlaceholder')"
                        dense
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2 class="mt-4 mb-4 px-2">
                    <v-menu
                        ref="dateMenu"
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                outlined
                                :value="dateRangeLabel"
                                :label="$t('cleaningLog.selectDateRange')"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                color="#213A8F"
                                dense
                            />
                        </template>
                        <v-date-picker
                            v-model="dateRange"
                            no-title
                            scrollable
                            :locale="$i18n.locale"
                            range
                            :max="maxDate"
                            :min="minDate"
                            @input="onDateRangePick"
                        >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="dateMenu = false">
                                {{ $t('common.cancel') }}
                            </v-btn>
                            <v-btn text color="primary" @click="$refs.dateMenu.save(dateRange); dateMenu = false">
                                {{ $t('common.ok') }}
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-flex>
            </v-layout>
            <!-- Filtri rapidi temporali (sotto i filtri sopra, solo su dati già ricevuti) -->
            <v-layout align-center class="ml-4 mr-4 mb-4">
                <v-flex xs6 sm6 md2 class="mt-6 mb-4 mr-4 ml-4 justify-left">
                    <h2 style="font-weight: bold; color: #213A8F;">{{ $t('cleaningLog.quickFilters') }}</h2>
                </v-flex>
                <v-flex xs6 sm6 md2>
                    <v-btn text @click="setQuickFilter('1')" class="mt-4 mb-4 mr-4 ml-4">
                        <h2 :style="'color: ' + (activeQuickFilter === '1' ? '#213A8F' : '#DAE0EC')">| {{ $t('cleaningLog.today') }} |</h2>
                    </v-btn>
                </v-flex>
                <v-flex xs6 sm6 md2>
                    <v-btn text @click="setQuickFilter('7')" class="mt-4 mb-4 mr-4 ml-4">
                        <h2 :style="'color: ' + (activeQuickFilter === '7' ? '#213A8F' : '#DAE0EC')">| {{ $t('cleaningLog.last7Days') }} |</h2>
                    </v-btn>
                </v-flex>
                <v-flex xs6 sm6 md2>
                    <v-btn text @click="setQuickFilter('14')" class="mt-4 mb-4 mr-4 ml-4">
                        <h2 :style="'color: ' + (activeQuickFilter === '14' ? '#213A8F' : '#DAE0EC')">| {{ $t('cleaningLog.last14Days') }} |</h2>
                    </v-btn>
                </v-flex>
                <v-flex xs6 sm6 md2>
                    <v-btn text @click="setQuickFilter('30')" class="mt-4 mb-4 mr-4 ml-4">
                        <h2 :style="'color: ' + (activeQuickFilter === '30' ? '#213A8F' : '#DAE0EC')">| {{ $t('cleaningLog.last30Days') }} |</h2>
                    </v-btn>
                </v-flex>
                <v-flex xs6 sm6 md2>
                    <v-btn text @click="setQuickFilter('all')" class="mt-4 mb-4 mr-4 ml-4">
                        <h2 :style="'color: ' + (activeQuickFilter === 'all' ? '#213A8F' : '#DAE0EC')">| {{ $t('cleaningLog.allPeriod') }} |</h2>
                    </v-btn>
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="ClearFilter">
                    <span style="color: #213A8F;">{{ $t('manageSensors.clearFilter') }}</span>
                    <v-icon color="#213A8F" left>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>

        <!-- Tabella Cleaning Log -->
        <v-card>
            <v-card-title class="d-flex justify-end align-center compact-title">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="#213A8F"
                            :class="['download-icon', { 'download-icon--disabled': filteredItems.length === 0 }]"
                            @click="filteredItems.length > 0 && exportToExcel()"
                        >mdi-download</v-icon>
                    </template>
                    <span>{{ $t('cleaningLog.downloadTooltip') }}</span>
                </v-tooltip>
            </v-card-title>
            <v-layout id="makeMeBlue">
                <v-flex xs12 sm12 md12>
                    <v-card-text>
                        <v-data-table 
                            class="cleaning-log-table elevation-1 mt-4"
                            v-bind:headers="headers" 
                            :items="filteredItems" 
                            :items-per-page="30"
                            :items-per-page-options="[10, 30, 50, 100, -1]"
                            :footer-props="{
                                itemsPerPageText: $t('common.itemsPerPage'),
                                itemsPerPageAllText: $t('common.all'),
                                pageText: '{0}-{1} ' + $t('common.of') + ' {2}',
                                itemsPerPageOptions: [10, 30, 50, 100, -1]
                            }" 
                            style="overflow-x: auto;" 
                            :no-data-text="$t('cleaningLog.noDataAvailable')">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <!-- Colonna vuota -->
                                    <td></td>
                                    <!-- Cleaned at -->
                                    <td>
                                        <div v-html="formatTimestamp(item.timestamp)"></div>
                                    </td>
                                    <!-- Location (Building / Floor / Area) -->
                                    <td>
                                        <div>
                                            <strong style="color: #213A8F;">{{ item.building || '-' }}</strong><br>
                                            <span style="color: #666; font-size: 0.9em;">{{ item.floor || '-' }}</span>
                                            <span v-if="item.area && item.area !== '-'" style="color: #666; font-size: 0.9em;"> / {{ item.area }}</span>
                                        </div>
                                    </td>
                                    <!-- Traffic since last clean -->
                                    <td>
                                        <strong style="color: #213A8F;">{{ item.trafficHandled || 0 }}</strong> pax
                                    </td>
                                    <!-- Trigger (Alert/Routine) — nascosto per Guest -->
                                    <td v-if="!isGuest">
                                        <v-chip
                                            :color="item.trigger === 'Alert' ? 'orange' : 'green'"
                                            text-color="white"
                                            small
                                        >
                                            {{ item.trigger }}
                                        </v-chip>
                                    </td>
                                    <!-- Reaction from alert — nascosto per Guest -->
                                    <td v-if="!isGuest">
                                        <span v-if="item.responseTime">{{ item.responseTime }}</span>
                                        <span v-else style="color: #999;">-</span>
                                    </td>
                                    <!-- Time since last cleaning -->
                                    <td>
                                        <span v-if="item.timeSinceLastCleaning">{{ item.timeSinceLastCleaning }}</span>
                                        <span v-else style="color: #999;">-</span>
                                    </td>
                                    <!-- Operator -->
                                    <td>
                                        <div v-if="item.operatorName">
                                            <strong>{{ item.operatorName }}</strong><br>
                                            <span style="color: #666; font-size: 0.9em;">{{ item.badgeNumber }}</span>
                                        </div>
                                        <div v-else>
                                            {{ item.badgeNumber || '-' }}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-flex>
            </v-layout>
        </v-card>

    </v-container>
</template>

<script>
import { formatDateDisplay, formatDateTimeDisplay, formatTimeDisplay, toBackendDate } from '@/utils/dateTimezone';
import axios from "axios";
import * as XLSX from 'xlsx';

export default {
    name: 'CleaningLogView',
    data() {
        return {
            areas: [],
            areaValue: '',
            buildings: [],
            buildingValue: '',
            floors: [],
            floorValue: '',
            operatorSearch: '',
            floorKey: 0,
            buildingKey: 0,
            overlay: false,
            items: [],
            // Filtro temporale (calendario + quick filter)
            dateRange: [],
            dateMenu: false,
            activeQuickFilter: '30',
            maxDate: '',
            minDate: '',
        }
    },
    computed: {
        isGuest() {
            const userRole = this.$store.state.userRole;
            if (Array.isArray(userRole) && userRole.length > 0) {
                return userRole[0].Name === 'Guest';
            }
            if (typeof userRole === 'string') {
                return userRole.toLowerCase() === 'guest';
            }
            return false;
        },
        dateRangeLabel() {
            if (!this.dateRange || this.dateRange.length === 0) return '';
            const from = this.dateRange[0];
            const to = this.dateRange.length > 1 ? this.dateRange[1] : this.dateRange[0];
            if (from === to) return this.formatDateLabel(from);
            return `${this.formatDateLabel(from)} – ${this.formatDateLabel(to)}`;
        },
        headers() {
            const all = [
                { text: '', value: 'empty', sortable: false, width: '40px' },
                { text: this.$t('cleaningLog.time'), align: "center", value: "timestamp" },
                { text: this.$t('cleaningLog.location'), align: "center", value: "location" },
                { text: this.$t('cleaningLog.trafficHandled'), align: "center", value: "trafficHandled" },
                { text: this.$t('cleaningLog.trigger'), align: "center", value: "trigger" },
                { text: this.$t('cleaningLog.responseTime'), align: "center", value: "responseTime" },
                { text: this.$t('cleaningLog.timeSinceLastCleaning'), align: "center", value: "timeSinceLastCleaning" },
                { text: this.$t('cleaningLog.operator'), align: "center", value: "operator" },
            ];
            if (this.isGuest) {
                return all.filter(h => h.value !== 'trigger' && h.value !== 'responseTime');
            }
            return all;
        },
        filteredItems() {
            let result = this.items;

            // Filtro temporale (dateRange / quick filter) — confronto in ora locale
            if (this.dateRange && this.dateRange.length > 0) {
                const start = this.dateRange[0];
                const end = this.dateRange.length > 1 ? this.dateRange[1] : this.dateRange[0];
                const startTs = new Date(start + 'T00:00:00').getTime();
                const endTs = new Date(end + 'T23:59:59.999').getTime();
                result = result.filter(item => {
                    const t = item.timestamp || (item._raw && ((item._raw.typeSpecificProps && item._raw.typeSpecificProps.timestamp) || item._raw.timestamp || item._raw.createdAt));
                    if (!t) return false;
                    const itemTime = new Date(t).getTime();
                    return itemTime >= startTs && itemTime <= endTs;
                });
            }

            // Filtri sulla location (dati già scaricati, nessuna chiamata API)
            if (this.buildingValue) {
                result = result.filter(item => (item.building || '-') === this.buildingValue);
            }
            if (this.floorValue) {
                result = result.filter(item => (item.floor || '-') === this.floorValue);
            }
            if (this.areaValue) {
                result = result.filter(item => (item.area || '-') === this.areaValue);
            }

            // Filtro operatore
            if (this.operatorSearch && this.operatorSearch.trim() !== '') {
                const searchTerm = this.operatorSearch.toLowerCase().trim();
                result = result.filter(item => {
                    const operatorName = (item.operatorName || '').toLowerCase();
                    const badgeNumber = String(item.badgeNumber || '').toLowerCase();
                    return operatorName.includes(searchTerm) || badgeNumber.includes(searchTerm);
                });
            }

            return result;
        }
    },
    created() {
        this.overlay = true;
        this.loadCleaningLog();
    },
    methods: {
        async loadCleaningLog() {
            this.overlay = true;
            try {
                const baseUrl = this.$store.state.BASE_URL || this.$store.state.BASE_PATH;
                const url = `${baseUrl}/v1/events`;
                
                const params = {
                    eventType: 'CLEANER_SCAN',
                    limit: 0
                };
                
                const token = localStorage.getItem('jwtToken');
                
                const response = await axios.get(url, {
                    params,
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                
                console.log('Cleaning Log API response:', response.data);
                
                // Mappa i dati per la tabella
                if (response.data && response.data.items && Array.isArray(response.data.items)) {
                    this.items = response.data.items.map(event => this.mapEventToTableRow(event));
                    this.buildLocationFiltersFromItems();
                    this.setDefaultDateRange();
                } else {
                    this.items = [];
                    this.buildings = [];
                    this.floors = [];
                    this.areas = [];
                    this.setDefaultDateRange();
                }
                
                this.overlay = false;
            } catch (error) {
                console.error('Errore nel caricamento del cleaning log:', error);
                this.items = [];
                this.setDefaultDateRange();
                this.overlay = false;
            }
        },
        
        buildLocationFiltersFromItems() {
            const buildingSet = new Set();
            const floorSet = new Set();
            const areaSet = new Set();
            this.items.forEach(item => {
                const b = item.building || '-';
                const f = item.floor || '-';
                const a = item.area || '-';
                if (b) buildingSet.add(b);
                if (f) floorSet.add(f);
                if (a) areaSet.add(a);
            });
            this.buildings = Array.from(buildingSet).sort().map(t => ({ text: t, value: t }));
            this.floors = Array.from(floorSet).sort().map(t => ({ text: t, value: t }));
            this.areas = Array.from(areaSet).sort().map(t => ({ text: t, value: t }));
            this.floorKey++;
            this.buildingKey++;
        },
        
        mapEventToTableRow(event) {
            // Estrai dati dall'evento
            const timestamp = event.timestamp || event.createdAt;
            const location = event.location || {};
            const typeSpecificProps = event.typeSpecificProps || {};
            
            // Determina il trigger (Alert o Routine): come backend, da clearedAlertsCount se possibile
            const trigger = (typeSpecificProps.clearedAlertsCount > 0)
                ? 'Alert'
                : (typeSpecificProps.trigger || (typeSpecificProps.buttonPressed === 1 ? 'Alert' : 'Routine'));
            
            // Tempo di intervento: dall'API o, per Alert senza valore, calcolato da oldestAlertTimestamp e timestamp
            let responseTime = typeSpecificProps.responseTime;
            if (responseTime !== undefined && responseTime !== null) {
                const ms = typeof responseTime === 'number' ? responseTime : Number(responseTime);
                responseTime = !isNaN(ms) ? this.formatResponseTime(ms) : null;
            } else if (trigger === 'Alert' && typeSpecificProps.timestamp && typeSpecificProps.oldestAlertTimestamp) {
                const scanMs = new Date(typeSpecificProps.timestamp).getTime();
                const oldestMs = new Date(typeSpecificProps.oldestAlertTimestamp).getTime();
                if (!isNaN(scanMs) && !isNaN(oldestMs)) {
                    responseTime = this.formatResponseTime(scanMs - oldestMs);
                } else {
                    responseTime = null;
                }
            } else {
                responseTime = null;
            }
            
            // Traffico gestito (washroomUsageBeforeScan)
            const trafficHandled = Math.floor(typeSpecificProps.washroomUsageBeforeScan || 0);

            // Tempo dall'ultima pulizia (top-level o dentro typeSpecificProps)
            const rawTimeSinceLastCleaning = typeSpecificProps.timeSinceLastCleaning ?? event.timeSinceLastCleaning;
            let timeSinceLastCleaning = null;
            if (rawTimeSinceLastCleaning !== null && rawTimeSinceLastCleaning !== undefined) {
                const ms = typeof rawTimeSinceLastCleaning === 'number' ? rawTimeSinceLastCleaning : Number(rawTimeSinceLastCleaning);
                timeSinceLastCleaning = !isNaN(ms) ? this.formatResponseTime(ms) : null;
            }
            
            return {
                timestamp: timestamp,
                building: location.building || '-',
                floor: location.floor || '-',
                area: location.area || '-',
                operatorName: typeSpecificProps.displayName || null,
                badgeNumber: typeSpecificProps.badgeNumber || '-',
                trigger: trigger,
                responseTime: responseTime,
                timeSinceLastCleaning: timeSinceLastCleaning,
                trafficHandled: trafficHandled,
                deviceId: event.deviceId,
                _raw: event
            };
        },
        
        formatTimestamp(timestamp) {
            if (!timestamp || timestamp === '-') {
                return '-';
            }
            try {
                const date = new Date(timestamp);
                if (isNaN(date.getTime())) return '-';
                const tz = this.$store.state.timezone || 'Europe/Rome';
                const formatted = formatDateTimeDisplay(date, tz);
                const [datePart, timePart] = formatted.split(' ');
                return `<span style="font-weight: bold; color: #213A8F;">${datePart}</span><br><span style="color: #666; font-size: 0.9em;">${timePart || ''}</span>`;
            } catch (error) {
                console.error('Error formatting timestamp:', error);
                return '-';
            }
        },
        
        formatResponseTime(milliseconds) {
            // Se il responseTime è già una stringa formattata, ritornala così com'è
            if (typeof milliseconds === 'string') {
                return milliseconds;
            }
            
            // Il dato è espresso in millisecondi: converti in formato leggibile
            if (!milliseconds || milliseconds < 0) {
                return '-';
            }
            
            const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
            const hours = Math.floor((milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
            
            let result = '';
            if (days > 0) result += `${days} d `;
            if (hours > 0) result += `${hours} h `;
            if (minutes > 0 || result === '') result += `${minutes} min`;
            
            return result.trim();
        },
        
        calculateDuration(startTime, endTime) {
            if (!startTime || !endTime) {
                return '-';
            }
            
            try {
                const start = new Date(startTime);
                const end = new Date(endTime);
                
                if (isNaN(start.getTime()) || isNaN(end.getTime())) {
                    return '-';
                }
                
                const diff = end - start;
                
                if (diff < 0) {
                    return '-';
                }
                
                // Convert to readable format
                const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                
                let result = '';
                if (days > 0) result += `${days} d `;
                if (hours > 0) result += `${hours} h `;
                if (minutes > 0 || result === '') result += `${minutes} min`;
                
                return result.trim();
            } catch (error) {
                console.error('Error calculating duration:', error);
                return '-';
            }
        },
        
        exportToExcel() {
            if (this.filteredItems.length === 0) {
                return;
            }
            const exportData = this.filteredItems.map(item => {
                const tz = this.$store.state.timezone || 'Europe/Rome';
                const formattedDate = formatDateDisplay(item.timestamp, tz);
                const formattedTime = formatTimeDisplay(item.timestamp, tz);
                const location = `${item.building || '-'} / ${item.floor || '-'}${item.area && item.area !== '-' ? ' / ' + item.area : ''}`;
                const operator = item.operatorName ? `${item.operatorName} (${item.badgeNumber})` : (item.badgeNumber || '-');

                const row = {
                    [this.$t('cleaningLog.date')]: formattedDate,
                    [this.$t('cleaningLog.time')]: formattedTime,
                    [this.$t('cleaningLog.location')]: location,
                    [this.$t('cleaningLog.trafficHandled')]: `${item.trafficHandled || 0} pax`,
                };

                // Colonne visibili solo per utenti non-Guest (coerente con headers() nell'interfaccia)
                if (!this.isGuest) {
                    row[this.$t('cleaningLog.trigger')] = item.trigger;
                    row[this.$t('cleaningLog.responseTime')] = item.responseTime || '-';
                }

                row[this.$t('cleaningLog.timeSinceLastCleaning')] = item.timeSinceLastCleaning || '-';
                row[this.$t('cleaningLog.operator')] = operator;

                return row;
            });

            // Larghezze colonne: adatta in base al numero di colonne (Guest ne ha 2 in meno)
            const colWidths = this.isGuest
                ? [{ wch: 12 }, { wch: 8 }, { wch: 30 }, { wch: 15 }, { wch: 20 }, { wch: 25 }]
                : [{ wch: 12 }, { wch: 8 }, { wch: 30 }, { wch: 15 }, { wch: 10 }, { wch: 15 }, { wch: 20 }, { wch: 25 }];

            const worksheet = XLSX.utils.json_to_sheet(exportData);
            worksheet['!cols'] = colWidths;
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Cleaning Log');
            const now = new Date();
            const fileName = `CleaningLog_${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}.xlsx`;
            XLSX.writeFile(workbook, fileName);
        },
        
        ClearFilter() {
            this.buildingValue = '';
            this.floorValue = '';
            this.areaValue = '';
            this.operatorSearch = '';
        },
        formatDateLabel(isoDateStr) {
            if (!isoDateStr) return '';
            const tz = this.$store.state.timezone || 'Europe/Rome';
            return formatDateDisplay(isoDateStr + 'T12:00:00', tz);
        },
        /** Restituisce YYYY-MM-DD in Europe/Rome per invio al backend (base dati italiana) */
        toLocalDateStr(d) {
            return toBackendDate(d);
        },
        setQuickFilter(period) {
            this.activeQuickFilter = period;
            const today = new Date();
            this.maxDate = this.toLocalDateStr(today);
            if (period === 'all') {
                this.dateRange = [];
                return;
            }
            const end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            if (period === '1') {
                // Oggi: stesso giorno
                this.dateRange = [this.toLocalDateStr(start), this.toLocalDateStr(end)];
            } else {
                const n = parseInt(period, 10);
                start.setDate(today.getDate() - n + 1);
                this.dateRange = [this.toLocalDateStr(start), this.toLocalDateStr(end)];
            }
        },
        onDateRangePick() {
            this.activeQuickFilter = null;
        },
        setDefaultDateRange() {
            const today = new Date();
            this.maxDate = this.toLocalDateStr(today);
            const oneYearAgo = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
            this.minDate = this.toLocalDateStr(oneYearAgo);
            const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            start.setDate(today.getDate() - 29);
            this.dateRange = [this.toLocalDateStr(start), this.toLocalDateStr(today)];
            this.activeQuickFilter = '30';
        },
    }
}
</script>

<style scoped>
.cleaning-log-table ::v-deep thead th,
.cleaning-log-table ::v-deep tbody td {
    text-align: center !important;
}

.compact-title {
    padding: 8px 16px 4px 16px !important;
}

.download-icon {
    font-size: 22px !important;
    cursor: pointer;
}
.download-icon:hover:not(.download-icon--disabled) {
    opacity: 0.8;
}
.download-icon--disabled {
    opacity: 0.4;
    cursor: not-allowed;
}
</style>
